require('../../modules/es6.number.parse-float');
module.exports = require('../../modules/_core').Number.parseFloat;



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/number/parse-float.js
// module id = 738
// module chunks = 20